import '@fontsource/unbounded/700.css';
import '@fontsource/unbounded/900.css';
import '@fontsource/plus-jakarta-sans/400.css';
import '@fontsource/plus-jakarta-sans/500.css';
import '@fontsource/plus-jakarta-sans/600.css';
import '@fontsource/plus-jakarta-sans/700.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/700.css';
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { UserProvider } from "@/context/UserContext";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import ClassesPage from "@/pages/ClassesPage";
import CoursePage from "@/pages/CoursePage";
import NotesPage from "@/pages/NotesPage";
import ProfilePage from "@/pages/ProfilePage";
import WallOfTradersPage from "@/pages/WallOfTradersPage";
import TraderDetailPage from "@/pages/TraderDetailPage";

function App() {
  return (
    <UserProvider>
      <div className="App min-h-screen bg-pump-black">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<HomePage />} />
              <Route path="classes" element={<ClassesPage />} />
              <Route path="course/:courseId" element={<CoursePage />} />
              <Route path="notes" element={<NotesPage />} />
              <Route path="profile" element={<ProfilePage />} />
              <Route path="wall-of-traders" element={<WallOfTradersPage />} />
              <Route path="wall-of-traders/:certificateId" element={<TraderDetailPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" theme="dark" />
      </div>
    </UserProvider>
  );
}

export default App;
